import PageShell from "@/components/site/PageShell";

export default function Privacy() {
  return (
    <PageShell title="Privacy Policy" testId="privacy-page">
      <div className="mx-auto max-w-3xl px-5 lg:px-8">
        <p className="text-[12px] font-bold uppercase tracking-widest text-terracotta">Legal</p>
        <h1 className="mt-3 text-4xl font-black leading-tight tracking-tight text-charcoal sm:text-5xl">
          Privacy Policy
        </h1>
        <p className="mt-3 text-[14px] font-semibold text-charcoal/55">Last updated: June 2026</p>

        <div className="prose-legal mt-10">
          <h2>Overview</h2>
          <p>
            Dishly connects independent food creators with nearby customers. This Privacy Policy
            explains what information we collect, how we use it, and the choices you have.
          </p>

          <h2>Information we collect</h2>
          <ul>
            <li>Account details, including your name and email.</li>
            <li>Approximate or precise location, only while using the app, to show nearby creators and calculate delivery.</li>
            <li>Order and payment records.</li>
            <li>Photos that creators upload of their meals.</li>
            <li>Messages and reviews you send within the app.</li>
            <li>For creators who choose to verify: identity and food-safety documents.</li>
          </ul>

          <h2>How we use it</h2>
          <p>We use the information above to:</p>
          <ul>
            <li>Operate the Dishly marketplace.</li>
            <li>Show nearby creators.</li>
            <li>Process orders and payouts.</li>
            <li>Enable chat and reviews between creators and customers.</li>
            <li>Prevent fraud and abuse.</li>
            <li>Grant verification badges to creators who pass review.</li>
          </ul>

          <h2>Payments</h2>
          <p>
            Card payments are processed by Stripe. We do not store full card numbers on our servers.
          </p>

          <h2>Document security</h2>
          <p>
            Verification documents are encrypted at rest, reviewed only by Dishly admins, and
            deleted when you delete your account.
          </p>

          <h2>Sharing</h2>
          <p>
            We share only what is needed to complete an order (for example, sharing a delivery
            address with the food creator or courier for that order). We do not sell personal data and
            do not use your data for third-party advertising or tracking.
          </p>

          <h2>Your rights</h2>
          <ul>
            <li>Edit your profile at any time inside the app.</li>
            <li>Revoke location permission in your device settings.</li>
            <li>Delete your account at any time. See our <a href="/delete-account">Delete Account</a> page for details.</li>
          </ul>

          <h2>Children</h2>
          <p>
            The Dishly service is for users 18 and older. We do not knowingly collect information
            from anyone under 18.
          </p>

          <h2>Contact</h2>
          <p>
            Questions about this Privacy Policy? Email us at{" "}
            <a href="mailto:support@dinewithdishly.co">support@dinewithdishly.co</a>.
          </p>
        </div>
      </div>
    </PageShell>
  );
}
